var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 71,
    viewBox: "0 0 114 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 26.3318,
    r: 25.5,
    fill: "#413DF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.633 69.5577L113.624 64.4766L108.549 64.52L108.559 69.6011L113.633 69.5577Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.614 59.3956L113.604 54.3145L108.529 54.3578L108.539 59.439L113.614 59.3956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.595 49.2332L113.585 44.1521L108.511 44.1955L108.521 49.2766L113.595 49.2332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.585 44.1522L113.576 39.071L108.501 39.1144L108.511 44.1956L113.585 44.1522Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.575 39.0707L113.565 33.9895L108.49 34.0329L108.5 39.1141L113.575 39.0707Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.555 28.9083L113.545 23.8271L108.471 23.8705L108.481 28.9517L113.555 28.9083Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.541 59.4388L108.531 54.3577L103.456 54.4011L103.466 59.4822L108.541 59.4388Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.49 34.0335L108.48 28.9524L103.406 28.9958L103.416 34.0769L108.49 34.0335Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.485 69.6448L103.476 64.5637L98.401 64.6071L98.4108 69.6882L103.485 69.6448Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.476 64.5633L103.466 59.4822L98.3912 59.5256L98.401 64.6067L103.476 64.5633Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.455 54.401L103.445 49.3198L98.3707 49.3632L98.3805 54.4444L103.455 54.401Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.436 44.2386L103.426 39.1575L98.3512 39.2009L98.361 44.282L103.436 44.2386Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.427 39.1578L103.417 34.0767L98.3424 34.1201L98.3522 39.2012L103.427 39.1578Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.406 28.9955L103.396 23.9143L98.3219 23.9577L98.3317 29.0389L103.406 28.9955Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3819 54.4452L98.3721 49.364L93.2975 49.4074L93.3073 54.4886L98.3819 54.4452Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3613 44.2823L98.3516 39.2012L93.277 39.2446L93.2868 44.3257L98.3613 44.2823Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3355 69.7313L93.3257 64.6501L88.2511 64.6935L88.2609 69.7747L93.3355 69.7313Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3169 59.5689L93.3071 54.4878L88.2326 54.5312L88.2424 59.6123L93.3169 59.5689Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3062 54.4881L93.2964 49.407L88.2218 49.4504L88.2316 54.5315L93.3062 54.4881Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2964 49.407L93.2866 44.3259L88.2121 44.3693L88.2219 49.4504L93.2964 49.407Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2866 44.326L93.2769 39.2449L88.2023 39.2883L88.2121 44.3694L93.2866 44.326Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2769 39.2445L93.2671 34.1633L88.1925 34.2067L88.2023 39.2879L93.2769 39.2445Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2515 64.6937L88.2417 59.6125L83.1671 59.6559L83.1769 64.7371L88.2515 64.6937Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.232 54.5311L88.2222 49.45L83.1476 49.4933L83.1574 54.5745L88.232 54.5311Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2124 44.3692L88.2026 39.2881L83.128 39.3315L83.1378 44.4126L88.2124 44.3692Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1929 34.2069L88.1831 29.1257L83.1085 29.1691L83.1183 34.2502L88.1929 34.2069Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1865 69.8179L83.1768 64.7368L78.1022 64.7802L78.112 69.8613L83.1865 69.8179Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1572 54.5746L83.1475 49.4934L78.0729 49.5368L78.0827 54.618L83.1572 54.5746Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1377 44.4122L83.1279 39.3311L78.0534 39.3744L78.0632 44.4556L83.1377 44.4122Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1084 29.1693L83.0986 24.0881L78.0241 24.1315L78.0339 29.2127L83.1084 29.1693Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0918 59.6993L78.082 54.6182L73.0074 54.6616L73.0172 59.7427L78.0918 59.6993Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.083 54.6185L78.0732 49.5374L72.9987 49.5807L73.0084 54.6619L78.083 54.6185Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0635 44.4559L78.0537 39.3748L72.9791 39.4181L72.9889 44.4993L78.0635 44.4559Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0332 29.2128L78.0234 24.1316L72.9488 24.175L72.9586 29.2561L78.0332 29.2128Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78.043 34.2938L78.0332 29.2126L72.9586 29.256L72.9684 34.3372L78.043 34.2938Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0371 69.9046L73.0273 64.8235L67.9528 64.8669L67.9626 69.948L73.0371 69.9046Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0283 64.8234L73.0186 59.7422L67.944 59.7856L67.9538 64.8667L73.0283 64.8234Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0186 59.7427L73.0088 54.6616L67.9342 54.705L67.944 59.7861L73.0186 59.7427Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9785 39.4181L72.9688 34.3369L67.8942 34.3803L67.904 39.4615L72.9785 39.4181Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9693 34.337L72.9595 29.2559L67.8849 29.2993L67.8947 34.3804L72.9693 34.337Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9595 29.256L72.9497 24.1748L67.8752 24.2182L67.8849 29.2994L72.9595 29.256Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9331 54.7049L67.9233 49.6238L62.8488 49.6672L62.8586 54.7483L67.9331 54.7049Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9048 39.4613L67.895 34.3801L62.8205 34.4235L62.8303 39.5047L67.9048 39.4613Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.895 34.3804L67.8853 29.2993L62.8107 29.3427L62.8205 34.4238L67.895 34.3804Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8687 59.8294L62.8589 54.7483L57.7843 54.7917L57.7941 59.8728L62.8687 59.8294Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8501 49.6666L62.8403 44.5854L57.7657 44.6288L57.7755 49.71L62.8501 49.6666Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8037 64.9542L57.7939 59.873L52.7194 59.9164L52.7292 64.9976L57.8037 64.9542Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7842 54.7921L57.7744 49.7109L52.6999 49.7543L52.7097 54.8355L57.7842 54.7921Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7647 44.6287L57.7549 39.5476L52.6803 39.591L52.6901 44.6721L57.7647 44.6287Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7354 29.3866L57.7256 24.3054L52.651 24.3488L52.6608 29.43L57.7354 29.3866Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7451 34.4674L57.7354 29.3862L52.6608 29.4296L52.6706 34.5107L57.7451 34.4674Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7393 70.0782L52.7295 64.9971L47.6549 65.0405L47.6647 70.1216L52.7393 70.0782Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7207 59.9166L52.7109 54.8354L47.6363 54.8788L47.6461 59.96L52.7207 59.9166Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6905 44.6732L52.6807 39.592L47.6061 39.6354L47.6159 44.7166L52.6905 44.6732Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6807 39.5914L52.6709 34.5103L47.5963 34.5536L47.6061 39.6348L52.6807 39.5914Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6612 29.4288L52.6514 24.3477L47.5768 24.3911L47.5866 29.4722L52.6612 29.4288Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6553 65.0406L47.6455 59.9595L42.571 60.0029L42.5807 65.084L47.6553 65.0406Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M47.606 39.6351L47.5962 34.554L42.5216 34.5973L42.5314 39.6785L47.606 39.6351Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5864 29.473L47.5767 24.3918L42.5021 24.4352L42.5119 29.5164L47.5864 29.473Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5708 60.003L42.561 54.9219L37.4865 54.9653L37.4963 60.0464L42.5708 60.003Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5601 54.9215L42.5503 49.8403L37.4757 49.8837L37.4855 54.9649L42.5601 54.9215Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5503 49.8404L42.5405 44.7593L37.466 44.8027L37.4758 49.8838L42.5503 49.8404Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5405 44.7598L42.5308 39.6787L37.4562 39.7221L37.466 44.8032L42.5405 44.7598Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5318 39.6783L42.522 34.5972L37.4474 34.6406L37.4572 39.7217L42.5318 39.6783Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5161 70.2088L37.5063 65.1277L32.4318 65.1711L32.4415 70.2522L37.5161 70.2088Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5054 65.1278L37.4956 60.0466L32.421 60.09L32.4308 65.1712L37.5054 65.1278Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4956 60.0467L37.4858 54.9656L32.4112 55.009L32.421 60.0901L37.4956 60.0467Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4771 49.8846L37.4673 44.8035L32.3927 44.8469L32.4025 49.928L37.4771 49.8846Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4673 44.8028L37.4575 39.7217L32.3829 39.7651L32.3927 44.8462L37.4673 44.8028Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4468 34.6409L37.437 29.5598L32.3624 29.6032L32.3722 34.6843L37.4468 34.6409Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4405 70.2515L32.4307 65.1704L27.3561 65.2138L27.3659 70.2949L32.4405 70.2515Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4209 60.0897L32.4111 55.0085L27.3366 55.0519L27.3464 60.1331L32.4209 60.0897Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4014 49.9273L32.3916 44.8462L27.3171 44.8896L27.3268 49.9707L32.4014 49.9273Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3819 39.7645L32.3721 34.6833L27.2975 34.7267L27.3073 39.8079L32.3819 39.7645Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3633 29.6031L32.3535 24.522L27.279 24.5654L27.2888 29.6465L32.3633 29.6031Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3574 65.2142L27.3477 60.1331L22.2731 60.1765L22.2829 65.2576L27.3574 65.2142Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3369 55.0519L27.3271 49.9707L22.2526 50.0141L22.2623 55.0953L27.3369 55.0519Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3272 49.9713L27.3174 44.8901L22.2428 44.9335L22.2526 50.0147L27.3272 49.9713Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3174 44.8902L27.3076 39.8091L22.233 39.8525L22.2428 44.9336L27.3174 44.8902Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2988 34.7276L27.2891 29.6465L22.2145 29.6899L22.2243 34.771L27.2988 34.7276Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepThree);
export default __webpack_public_path__ + "static/media/stepThree.f1a3de9faac186b288d21bfb13eabce3.svg";
export { ForwardRef as ReactComponent };